/**
 * QuestionControlsV2 - Container for confidence and mark for review controls
 *
 * Features:
 * - Confidence level selector
 * - Mark for review toggle
 * - Navigation keyboard hints
 * - Compact, modern design
 */

import { memo } from 'react'
import ConfidenceSelectorV2 from './ConfidenceSelectorV2'
import MarkForReviewV2 from './MarkForReviewV2'

const QuestionControlsV2 = memo(() => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Confidence Selector */}
        <ConfidenceSelectorV2 />

        {/* Divider (mobile) */}
        <div className="h-px sm:h-8 sm:w-px bg-gray-200 dark:bg-gray-700 sm:mx-4" />

        {/* Mark for Review */}
        <MarkForReviewV2 />
      </div>

      {/* Navigation hints - desktop only */}
      <div className="hidden md:flex items-center justify-center gap-6 mt-4 pt-4 border-t border-gray-200 dark:border-gray-700 text-xs text-gray-500 dark:text-gray-400">
        <span className="flex items-center gap-1.5">
          <kbd className="px-1.5 py-0.5 bg-gray-100 dark:bg-gray-700 rounded border border-gray-300 dark:border-gray-600 font-mono">
            Enter
          </kbd>
          <span>Next</span>
        </span>
        <span className="flex items-center gap-1.5">
          <kbd className="px-1.5 py-0.5 bg-gray-100 dark:bg-gray-700 rounded border border-gray-300 dark:border-gray-600 font-mono">
            Alt+Enter
          </kbd>
          <span>Back</span>
        </span>
        <span className="flex items-center gap-1.5">
          <kbd className="px-1.5 py-0.5 bg-gray-100 dark:bg-gray-700 rounded border border-gray-300 dark:border-gray-600 font-mono">
            P
          </kbd>
          <span>Pause</span>
        </span>
        <span className="flex items-center gap-1.5">
          <kbd className="px-1.5 py-0.5 bg-gray-100 dark:bg-gray-700 rounded border border-gray-300 dark:border-gray-600 font-mono">
            Ctrl+R
          </kbd>
          <span>Review</span>
        </span>
        <span className="flex items-center gap-1.5">
          <kbd className="px-1.5 py-0.5 bg-gray-100 dark:bg-gray-700 rounded border border-gray-300 dark:border-gray-600 font-mono">
            Ctrl+Enter
          </kbd>
          <span>Submit</span>
        </span>
      </div>
    </div>
  )
})

QuestionControlsV2.displayName = 'QuestionControlsV2'

export default QuestionControlsV2
